// assets
import { IconKey, IconUserPlus ,IconWallet} from '@tabler/icons';

// constant
const icons = {
  IconKey,
  IconUserPlus,
  IconWallet
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

// const userType = sessionStorage.getItem('UserType');

const Wallet = {
  id: 'wallet',
  title: 'Wallet',
  type: 'group',
  display_id: 'V',
  icon: icons.IconWallet,
  children: [
    
    {
      id: 'wallet',
      title: 'Wallet',
      type: 'item',
      display_id: 108,
      url: '/Admin/wallet',
      breadcrumbs: false
    },
    {
      id: 'wallet_topup',
      title: 'DS Topup Request',
      type: 'item',
      display_id: 109,
      url: '/Admin/ds_wallet_topup_request',
      breadcrumbs: false
    },
    
    {
      id: 'hardware_request',
      title: 'Hardware Request',
      type: 'item',
      display_id: 110,
      url: '/Admin/hardware_request',
      breadcrumbs: false
    },
    {
      id: 'bankdeposit_request',
      title: 'Bank Deposit Request',
      type: 'item',
      display_id: 111,
      url: '/Admin/bankdeposit_request',
      breadcrumbs: false
    },
    {
      id: 'ds_payment_link',
      title: 'DS Payment Link',
      type: 'item',
      display_id: 112,
      url: '/Admin/ds_payment_link',
      breadcrumbs: false
    },
    {
        id: 'csp_mapping',
        title: 'CSP Mapping Request',
        type: 'item',
        display_id: 114,
        url: '/Admin/csp_mapping_request',
        breadcrumbs: false
      },
  ].filter(Boolean)
};

export default Wallet;
